import { Component } from '@angular/core';

import { CardComponent } from '../../../core/components/card/card.component';
import { StatCard, ActivityItem } from '../../interfaces/admin.type';

@Component({
  selector: 'app-overview',
  imports: [CardComponent],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss'
})
export class OverviewComponent {
  protected readonly stats: StatCard[] = [
    { icon: '👥', label: 'Total Users', value: '4,218', change: '+3.2%', positive: true },
    { icon: '🟢', label: 'Active Today', value: '862', change: '+1.8%', positive: true },
    { icon: '🕌', label: 'Masjids Listed', value: '156', change: '+4', positive: true },
    { icon: '⚠️', label: 'Pending Reports', value: '7', change: '-2', positive: false }
  ];

  protected readonly recentActivity: ActivityItem[] = [
    { actor: 'Ahmed K.', action: 'submitted a new masjid listing', time: '5 min ago' },
    { actor: 'Fatima S.', action: 'reported an incorrect prayer time', time: '22 min ago' },
    { actor: 'System', action: 'completed daily prayer times sync', time: '1 hour ago' },
    { actor: 'Yusuf R.', action: 'created a new account', time: '2 hours ago' },
    { actor: 'Admin', action: 'updated Islamic calendar events', time: '4 hours ago' }
  ];
}
